import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitter } from '@angular/core';
import { ModalPopupType } from '../../models/modalPopupType';

@Component({
    standalone: false,
    selector: "app-modal-popup",
    templateUrl: "./modal-popup.component.html",
    styleUrls: ["./modal-popup.component.css"],
})
export class ModalPopupComponent implements OnInit {
    @ViewChild("template") template: TemplateRef<any>;
    @Output() clickedYes = new EventEmitter<void>();
    @Output() clickedCancel = new EventEmitter<void>();
    @Input() message: string;
    @Input() submessage: string;
    @Input() customYesText: string;
    @Input() customNoText: string; 
    @Input() hideCancelButton: boolean;
    @Input() marginLeft = 25;
    modalType: ModalPopupType;
    modalRef: BsModalRef;
    resolveFunc: any;
    config = {
        animated: true,
        class: "modal-dialog-centered",
    };

    constructor(private bsModalService: BsModalService) {}

    ngOnInit(): void {}

    show(modalPopupType: number, message?: string, submessage?: string) {
        if (message) {
            this.message = message;
        }
        if (submessage) {
            this.submessage = submessage;
        }
        this.modalType = modalPopupType;
        this.modalRef = this.bsModalService.show(this.template, this.config);
    }

    open(modalPopupType: number): Promise<void> {
        this.modalType = modalPopupType;
        this.modalRef = this.bsModalService.show(this.template, this.config);
        let promise = new Promise<void>((resolve, reject) => {
            this.resolveFunc = resolve;
        });
        return promise;
    }

    yes() {
        this.clickedYes.emit();
        if (this.resolveFunc) this.resolveFunc();
        this.modalRef.hide();
    }

    cancel() {
        this.clickedCancel.emit();
        this.resolveFunc = undefined;
        this.modalRef.hide();
    }
   close(): void {
        this.modalRef?.hide();
    }

}


